/* eslint-disable react/self-closing-comp */
// @ts-ignore
import React from "react";

import { SvgContainer } from "./svg-container";

export const BullHornIcon = () => {
    return (
        <SvgContainer>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMinYMin meet"
                viewBox="0 0 36 36"
            >
                <path
                    opacity={0.5}
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M22.35,29.44a3.61,3.61,0,0,1-7.22,0V25.6l-2.94-.86c0,.09,0,.18,0,.27v4.43a6.56,6.56,0,0,0,13.12,0v-.88l-2.95-.86Z"
                ></path>
                <path
                    opacity={0.5}
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M1.84,12.22l1.48-.58v-.15a1.48,1.48,0,0,0-2.95.07v10.9a1.48,1.48,0,0,0,2.95-.07v-.23l-1.48-.43Z"
                ></path>
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M33,.14,3.32,11.64l-1.48.58v9.51l1.48.43,8.87,2.58,2.94.86,7.22,2.1,2.95.86,7.81,2.28A2,2,0,0,0,35.63,29V2A2,2,0,0,0,33,.14Z"
                ></path>
            </svg>
        </SvgContainer>
    );
};
